import useApi from '../useApi';

export const useUpdateUser = () => {
  const {
    data: response,
    loading,
    error,
    postData,
  } = useApi('/BlazorApi/updateda', 'POST', null, 500000);

  const createUpdateUser = async (body) => {
    const res = await postData({ ...body, RegistrationSource: 1 });
    // if (res?.status === true) {
    //   queryClient.invalidateQueries({
    //     queryKey: ['users'],
    //   });
    // }
    return res;
  };

  return { response, loading, error, createUpdateUser };
};
